import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UserDialogComponent } from '../user-dialog/user-dialog.component';


@Component({
  selector: 'app-add-user-project',
  templateUrl: './add-user-project.component.html',
  styleUrl: './add-user-project.component.css'
})
export class AddUserProjectComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['srNo', 'userName', 'startDate', 'endDate','action'];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  projectId: any;

  constructor(private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog) {

  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.projectId = params['id'];

    });
    if (this.projectId) {
      this.getProjectDetails();
    }
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  getProjectDetails() {
    const params = { projectId: this.projectId };
    console.log(params)
    this.apiService.getProject(params).subscribe({
      next: (res: any) => {
        const data = res.find((project: any) => project.project_id == this.projectId);
        this.dataSource.data = data?.users;
        console.log(data?.users)

      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
  }
  deleteProject(a: any) {

  }
  // Open the dialog
  openAddUserDialog(): void {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '500px',
      disableClose: true,
      data: null // Can pass data for edit
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result)
        // this.documents.push(this.createDocGroup(result));
        // const data = {
        //   id: [25, 26, 27, 28],
        //   start_date: new Date("2025-06-25"),
        //   end_date: new Date("2025-06-30")
        // };

        const results = result.id.map((itemId: any) => {
          return {
            id: itemId,
            start_date: result.start_date,
            end_date: result.end_date
          };
        });

        console.log(results);
        const formData = new FormData();
        formData.append('users', JSON.stringify(results));
        this.apiService.updateProjectDoc(this.projectId, formData).subscribe({
          next: (res) => {
            console.log(res);
            this.getProjectDetails();
            this.toastrMsgService.success("Users saved successfully");
          },
          error: (err) => {
            console.error(err);
            this.toastrMsgService.error(err.error.errorMessage);
          },
          complete: () => console.log("Observable complete"),
        });
      }
    });
  }
  // Open the dialog
  openAddUserEditDialog(data: any): void {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '500px',
      disableClose: true,
      data: { ...data }// Can pass data for edit
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result)
         const results = result.id.map((itemId: any) => {
          return {
            id: itemId,
            start_date: result.start_date,
            end_date: result.end_date
          };
        });

        console.log(results);
        const formData = new FormData();
        formData.append('users', JSON.stringify(results));
        this.apiService.updateProjectDoc(this.projectId, formData).subscribe({
          next: (res) => {
            console.log(res);
            this.getProjectDetails();
            this.toastrMsgService.success("Users saved successfully");
          },
          error: (err) => {
            console.error(err);
            this.toastrMsgService.error(err.error.errorMessage);
          },
          complete: () => console.log("Observable complete"),
        });
      }
    });
  }
}